<txp-loading *ngIf="isLoading" [color]="loadingColor.COLOR"></txp-loading>

<form class="select-items" [formGroup]="form" *ngIf="!isLoading">
    <mat-form-field [hidden]="hideQty">
        <mat-label>{{ 'coupons.edit.customer.items.quantity' | translate }} </mat-label>
        <input formControlName="quantity"
               data-qa-label="Quantity"
               (change)="onQuantityChange()"
               matInput
               txpIntegersOnly/>
        <mat-hint>{{ 'form.hint.integersOnly' | translate }}</mat-hint>
        <mat-error>
            {{ 'form.error.required' | translate }}
        </mat-error>
    </mat-form-field>

    <txp-button class="add-items-button"
                [style]="buttonStyle.SECONDARY"
                data-qa-label="AddItemsButton"
                [disabled]="disableCustomerGets"
                (click)="addItemsDialog('add')">
        {{ 'coupons.edit.customer.addItems'| translate }}
    </txp-button>
    <txp-button class="search-items-button"
                [style]="buttonStyle.SECONDARY"
                data-qa-label="SearchItemsButton"
                [disabled]="disableCustomerGets"
                (click)="addItemsDialog('search')">
        {{ 'coupons.edit.customer.searchItems'| translate }}
    </txp-button>
</form>


<div class="list-container" *ngIf="!isLoading">
    <txp-loading *ngIf="isLoading" [color]="loadingColor.COLOR"></txp-loading>
    <div class="list-items-header">
        <div class="item-name">{{"coupons.edit.customer.items.name" | translate}}</div>
        <div class="item-type">{{"coupons.edit.customer.items.type" | translate}}</div>
        <div class="item-name">{{"coupons.edit.customer.items.id" | translate}}</div>
        <div class="item-name">{{"coupons.edit.customer.items.plu" | translate}}</div>
    </div>
    <hr>
    <div *ngIf="itemsList?.length" class="list-items-container" >
        <div *ngFor="let item of itemsList" class="list-items" data-qa-label="ListItem">
            <div class="item-row">
                <div class="item-name">{{item?.name}}</div>
                <div class="item-name">{{"coupons.edit.customer.items."+ item?.type | translate}}</div>
                <div class="item-name">{{item?.id}}</div>
                <div class="item-name">{{item?.plu}}</div>
            </div>
        <hr>
        </div>
    </div>
    <div class="messages">
        <txp-message [type]="messageType.DANGER"
                     *ngIf="loadItemsError"
                     data-qa-label="LoadItemsError">
            {{ 'coupons.edit.customer.items.loadItemsErrorMsg' | translate }}
        </txp-message>
        <txp-message [type]="messageType.WARNING"
                     *ngIf="!formSubmitted && !itemsList?.length"
                     data-qa-label="ItemsListEmpty">
            {{ 'coupons.edit.customer.items.emptyItemsList' | translate }}
        </txp-message>
        <txp-message [type]="messageType.DANGER"
                     *ngIf="formSubmitted && itemsRequired && !itemsList?.length"
                     data-qa-label="ItemsRequired">
            {{ 'coupons.edit.customer.items.itemsRequired' | translate }}
        </txp-message>
    </div>

</div>